module.exports = __webpack_public_path__ + "img/icon-white-13.7778280a.svg";